import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { AVAILABILITY_TOTAL_STEPS, resolveAvailabilityStepsPresentation, } from '../../utils/resolveAvailabilityStepsPresentation';
export function ParkingInformationAvailabilityIndicator({ available, total, isLotMode, testId }) {
    const isFree = available > 0;
    const finalTestId = testId.append(isFree ? 'free' : 'unavailable');
    if (!isLotMode) {
        return (_jsx("span", { className: classNames('inline-block h-2 w-2 rounded-full', {
                'bg-fg-success': isFree,
                'bg-fg-danger': !isFree,
            }), "data-testid": finalTestId }));
    }
    const { filledSteps, fillClassName, label } = resolveAvailabilityStepsPresentation(available, total);
    return (_jsxs("div", { className: "mr-1 inline-flex items-center gap-2", "data-testid": finalTestId, children: [_jsx("span", { className: "text-body-subtle min-w-0 flex-1 truncate text-xs", title: label, children: label }), _jsx("div", { className: "flex shrink-0 items-center gap-0.5", children: Array.from({ length: AVAILABILITY_TOTAL_STEPS }, (_unused, index) => {
                    const isFilled = index < filledSteps;
                    return (_jsx("div", { className: `h-3 w-1 rounded-full ${isFilled ? fillClassName : 'bg-stroke-base-medium'}` }, index));
                }) })] }));
}
